import React from "react";
import { Button, Tabs } from "antd";
import { UnsubscribedPlanDetails } from "./UnsubscribedPlanDetails";
import { UnsubscribedPaymentButton } from "./UnsubscribedPaymentButton";
import languageFile from "../../../../public/languages/Translation";
import { urlName } from "../../../config/index";
import styles from "./style.module.scss";
import { UpdateCardModalWindow } from "./UpdateCardModalWinodw";

const TabPane = Tabs.TabPane;
export const UnsubscribedSubscriptionPlan = ({ openPaymentPortal,reActiveConfirmation,getHostPage,openPaymentModal,handleCancel,handleOk }) => {
        return (
        <div className={styles.outerPage}>
            <div className={styles.paymentBlock}>
                <div className={styles.heading}>
                    <h2>Welcome Back!</h2>
                </div>
                <div className={styles.description}>
                    Reactivate your subscription with the same pricing and features as before.
                    <p>Continue from where you left of.</p>
                </div>
                <div className={styles.buttonblock}>
                    <Button
                        type="primary"
                        onClick={getHostPage}>
                        Update Card
                    </Button>
                    <Button
                        type="primary"
                        onClick={reActiveConfirmation}>
                        Reactivate
                    </Button>
                </div>
            </div>
            <UpdateCardModalWindow
                            openPaymentModal={openPaymentModal}
                            handleCancel={handleCancel}
                            handleOk={handleOk}
                        />
        </div>
    );
};
